import script from "./UserPurchaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPurchaseModal.vue?vue&type=script&setup=true&lang=js"

import "./UserPurchaseModal.vue?vue&type=style&index=0&id=0cff7f78&lang=css"

const __exports__ = script;

export default __exports__